export default "__VITE_ASSET__CZ_mBiQ6__"